import * as React from "react";
import { getBexApiContext } from "bernie-context";
import { ComponentProps } from "typings/flexFramework/FlexComponent";
import { ContextInput } from "__generated__/api";

export interface PropertyBexApiComponentProps {
  inputs: {
    context?: ContextInput;
    propertyId: string;
  };
}

/**
 * Used to wrap Shared UI or Bex API components relevant to Properties.
 *
 * See PropertyReviewsWrapper or PropertyReviewsHeadline for example.
 * @param Component
 * @param additionalInputs
 * @constructor
 */
export const PropertyBexApiWrapper = (Component: React.ComponentType<any>, additionalInputs?: any) => (
  props: ComponentProps
) => {
  const context = props.context;

  if (
    !context ||
    !context.searchContext ||
    !context.searchContext.location ||
    !context.searchContext.location.name ||
    context.searchContext.location.type !== "hotel"
  ) {
    return null;
  }

  const inputs = {
    context: getBexApiContext(context),
    propertyId: String(context.searchContext.location.id),
    ...additionalInputs,
  };

  return <Component inputs={inputs} />;
};
